import { useState } from 'react'
import { useIntl } from 'react-intl'
import { notifyError } from '../services/ToastifyService/ToastifyService'
import { getComp } from '../utils/utils/DI'
import { DefaultImageItem } from '../views/RequestsManagement/components/InstalationRequestDrawer/components/NewPhotoUploadForm'

export const useFileLoader = (name: string) => {
  const intl = useIntl()
  const [files, setFiles] = useState<DefaultImageItem[] | null>(null)
  const photoPermission = getComp('PhotoSettingsStore')._photoSettings[name]

  const handleSetFiles = (newFiles: FileList) => {
    const updatedFiles: DefaultImageItem[] = files ? [...files] : []

    for (let fileNumber in newFiles) {
      const isTooManyPics =
        updatedFiles?.length >= photoPermission.maxLimitPerLoad

      if (isTooManyPics || fileNumber === 'length') {
        return
      } else {
        if (newFiles[fileNumber].size > photoPermission.maxImageSizeInBytes) {
          notifyError(
            `${intl.formatMessage(
              {
                id: 'Размер файла превышает {size} мегабайт',
                defaultMessage: 'Размер файла превышает {size} мегабайт',
              },
              {
                size: photoPermission.maxImageSizeInBytes / 1000000,
              },
            )}: ${newFiles[fileNumber].name}`,
          )
        } else {
          updatedFiles.push({
            file: newFiles[fileNumber],
            url: URL?.createObjectURL(newFiles[fileNumber]),
          })

          setFiles(updatedFiles)
        }
      }
    }
  }

  const deleteFile = (file: DefaultImageItem) => {
    if (!files) {
      return
    }

    const updatedFiles = files?.filter((f) => f.url !== file.url)

    if (!updatedFiles.length) {
      setFiles(null)
    } else {
      setFiles(updatedFiles)
    }
  }

  const filesError = photoPermission.minLimitPerLoad > (files ?? [])?.length

  return {
    files,
    handleSetFiles,
    deleteFile,
    photoPermission,
    filesError,
  }
}
